import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { EcomChangepasswordComponent } from './ecom-account/ecom-changepassword/ecom-changepassword.component';
import { EcomForgotPasswordComponent } from './ecom-account/ecom-forgot-password/ecom-forgot-password.component';
import { EcomOlarPointsComponent } from './ecom-account/ecom-olar-points/ecom-olar-points.component';
import { EcomOrdersComponent } from './ecom-account/ecom-orders/ecom-orders.component';
import { PaymentCanDeactivateGaurdService } from './ecom-account/ecom-payment-methods/ecom-payment-can-deactivate-guard.service';
import { EcomPaymentMethodsComponent } from './ecom-account/ecom-payment-methods/ecom-payment-methods.component';
import { EcomProfileEditComponent } from './ecom-account/ecom-profile/ecom-profile-edit/ecom-profile-edit.component';
import { EcomProfileComponent } from './ecom-account/ecom-profile/ecom-profile.component';
import { EcomReferralsComponent } from './ecom-account/ecom-referrals/ecom-referrals.component';
import { EcomSigninLoyaltyComponent } from './ecom-account/ecom-signin-loyalty/ecom-signin-loyalty.component';
import { EcomSigninNewComponent } from './ecom-account/ecom-signin-new/ecom-signin-new.component';
import { EcomVouchersComponent } from './ecom-account/ecom-vouchers/ecom-vouchers.component';
import { GiftCardResultComponent } from './ecom-gift-card-result/ecom-gift-card-result.component';
import { GiftCardComponent } from './ecom-gift-card/ecom-gift-card.component';
import { InvalidComponent } from './ecom-invalid-page/ecom-invalid-page.component';
import { CheckoutCanDeactivateGaurdService } from './ecom-items/ecom-item-cart-checkout/ecom-checkout-can-deactivate-guard.service';
import { EcomItemCartCheckoutComponent } from './ecom-items/ecom-item-cart-checkout/ecom-item-cart-checkout.component';
import { EcomItemCartComponent } from './ecom-items/ecom-item-cart/ecom-item-cart.component';
import { EcomPromotionsComponent } from './ecom-items/ecom-item-cart/ecom-promotions/ecom-promotions.component';
import { NewEcomItemCategoryV2Component } from './ecom-items/new-ecom-item-category-v2/new-ecom-item-category-v2.component';
import { NewEcomItemCategoryComponent } from './ecom-items/new-ecom-item-category/new-ecom-item-category.component';
import { EcomMessageRedirectComponent } from './ecom-message-redirect/ecom-message-redirect.component';
import { EcomFiltersComponent } from './ecom-navbars/ecom-filters/ecom-filters.component';
import { EcomStatusCollectionComponent } from './ecom-order-status/ecom-status-collection/ecom-status-collection.component';
import { EcomStatusDeliveryComponent } from './ecom-order-status/ecom-status-delivery/ecom-status-delivery.component';
import { EcomStatusDineinComponent } from './ecom-order-status/ecom-status-dinein/ecom-status-dinein.component';
import { EcomNetworkCheckComponent } from './ecom-shared/ecom-network-check/ecom-network-check.component';
import { GoogleAuthPopupComponent } from './ecom-socials/google-auth/google-auth-popup/google-auth-popup.component';
import { EcomStoresComponent } from './ecom-stores/ecom-stores.component';
import { EcomSupportCenterComponent } from './ecom-support-center/ecom-support-center.component';
import { EcomUnauthorizedComponent } from './ecom-unauthorized/ecom-unauthorized.component';



export const routes: Routes = [

  // {
  //   path: '',
  //   redirectTo: '/home',
  //   pathMatch: 'full',
  // },
  {
    path: '',
    component: InvalidComponent,
    data: { title: 'Invalid' }
  },
  {
    path: 'networkissue',
    component: EcomNetworkCheckComponent,
    data: { title: 'Internet' }
  },
  {
    path: 'promotions',
    component: EcomPromotionsComponent,
    data: { title: 'Promotions' }
  },
  {
    path: 'filters',
    component: EcomFiltersComponent,
    data: { title: 'Filters' }
  },
  {
    path: 'changepassword',
    component: EcomChangepasswordComponent,
    data: { title: 'Change Password' }
  },
  {
    path: 'forgotpassword',
    component: EcomForgotPasswordComponent,
    data: { title: 'Forgot Password' }
  },
  {
    path: 'home',
    component: InvalidComponent,
    data: { title: 'Home' }
  },
  {
    path: 'profile',
    component: EcomProfileComponent,
    data: { title: 'Profile' }
  },
  {
    path: 'orders',
    component: EcomOrdersComponent,
    data: { title: 'Orders' }
  },
  {
    path: 'cart/:companyname',
    component: EcomItemCartComponent,
    data: { title: 'Cart' }
  },
  {
    path: 'profile-edit',
    component: EcomProfileEditComponent,
    data: { title: 'Profile' }
  },
  {
    path: 'payment-methods/:companyname',
    component: EcomPaymentMethodsComponent,
    data: {
      externalUrl: 'https://staging-gateway.revpay.com.my/payment'
    },
    canDeactivate: [PaymentCanDeactivateGaurdService]
  },
  {
    path: 'stores',
    component: EcomStoresComponent,
    data: { title: 'Stores' }
  },
  // {
  //   path: 'login',
  //   component: EcomSigninComponent,
  //   data: { title: 'Login' }
  // },
  {
    path: 'loginnew',
    component: EcomSigninNewComponent,
    data: { title: 'Login' }
  },
  {
    path: 'signin',
    component: EcomSigninLoyaltyComponent,
    data: { title: 'Signgin' }
  },
  {
    path: 'giftcard',
    //component: EcomItemCategoryComponent,
    component: GiftCardComponent,
    data: { title: 'Buy Giftcard' }
  },
  {
    path: 'giftcard/result',
    //component: EcomItemCategoryComponent,
    component: GiftCardResultComponent,
    data: { title: 'Giftcard Result' }
  },
  {
    path: 'items/:companyname',
    //component: EcomItemCategoryComponent,
    component: NewEcomItemCategoryComponent,
    data: { title: 'Items' }
  },
  {
    path: 'items-v2/:companyname',
    component: NewEcomItemCategoryV2Component,
    data: { title: 'Items' }
  },
  {
    path: 'status-dinein',
    component: EcomStatusDineinComponent,
    data: { title: 'Status' }
  },
  {
    path: 'status-collection',
    component: EcomStatusCollectionComponent,
    data: { title: 'Status' }
  },
  {
    path: 'status-delivery',
    component: EcomStatusDeliveryComponent,
    data: { title: 'Status' }
  },
  {
    path: 'user-referrals',
    component: EcomReferralsComponent,
    data: { title: 'Referrals' }
  },
  {
    path: 'checkout/:companyname',
    component: EcomItemCartCheckoutComponent,
    data: { title: 'checkout' },
    canDeactivate: [CheckoutCanDeactivateGaurdService]
  },
  {
    path: 'm',
    component: EcomMessageRedirectComponent,
    data: { title: 'Message Redirect' }
  },
  {
    path: 'unauthorized',
    component: EcomUnauthorizedComponent,
    data: { title: 'Un-Authorized' }
  },
  {
    path: 'support',
    component: EcomSupportCenterComponent,
    data: { title: 'Support' }
  },
  {
    path: 'user-vouchers',
    component: EcomVouchersComponent,
    data: { title: 'Vouchers' }
  },
  {
    path: 'olar-points',
    component: EcomOlarPointsComponent,
    data: { title: 'Olar Points' }
  },
  { path: 'google/callback', component: GoogleAuthPopupComponent },
  { path: '**', component: InvalidComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
